"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSierraLoader = exports.useShouldShowOnScrolling = exports.useIsExpandedText = exports.isSierraLoaded = void 0;
var _react = require("react");
var _constants = require("./constants");
const isSierraLoaded = () => !!window?.sierra;
exports.isSierraLoaded = isSierraLoaded;
const useSierraLoader = () => {
  const [isScriptLoaded, setIsScriptLoaded] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (isSierraLoaded()) {
      setIsScriptLoaded(true);
      return;
    }
    const config = {
      display: "corner"
    };
    window.sierraConfig = config;
    const agentScript = document.createElement("script");
    agentScript.type = "module";
    agentScript.src = _constants.SIERRA_EMBED_SRC;
    document.head.appendChild(agentScript);
    agentScript.onload = () => setIsScriptLoaded(true);
  }, []);
  return isScriptLoaded;
};
exports.useSierraLoader = useSierraLoader;
const useIsExpandedText = () => {
  const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const timer = setTimeout(() => setIsExpanded(true), _constants.OPEN_CHAT_BTN_ANIMATION_DURATION);
    return () => clearTimeout(timer);
  }, []);
  return isExpanded;
};
exports.useIsExpandedText = useIsExpandedText;
const useShouldShowOnScrolling = () => {
  const [shouldShow, setShouldShow] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const isScrollable = document.documentElement.scrollHeight > window.innerHeight;
    if (!isScrollable) {
      setShouldShow(true);
      return;
    }
    const handleScroll = () => setShouldShow(true);
    window.addEventListener("scroll", handleScroll, {
      once: true
    });
  }, []);
  return shouldShow;
};
exports.useShouldShowOnScrolling = useShouldShowOnScrolling;